import React, { useEffect, useState, useContext, useRef } from "react";
import { getRatesList,getRatesListByFilter } from "../../../Services/Rates.service";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TableViewIcon from "@mui/icons-material/TableView";
import Switch from "@mui/material/Switch";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import RateCalendarByCity from "../../RateCalenderByCity/RateCalendarByCity";
import SharedDataContext from "../../../_helper/SharedData";
import { RateReviewTwoTone } from "@mui/icons-material";
import Rates from "../../Rates";
import Select from "react-select";
import {
  Box,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Skeleton,
} from "@mui/material";
// import { useNavigation } from "react-router";
import moment from "moment";
import editBlackIcon from "../../../assets/images/tarrifManagement/EditBlack.svg";
import RateInput from "../../Rates/RateInput";
import CustomizerContext from "../../../_helper/Customizer";
import { useTariffSearch } from "../../../_helper/TariffSearchContext/TariffSeachContext";

function RatesListView() {
  const { cityData, globalCityField, airportData } = useContext(SharedDataContext);
  const {
      searchData,
      setSearchData,
      filterData,
      setFilterData,
      filterType,
      setFilterType,
      ratesPagination,
      setRatesPagination
    } = useTariffSearch();

  const [ratesList, setRatesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChecked, setChecked] = useState(true);
  const [citySelected, setCitySelected] = useState();
  const [cityId, setCityId] = useState();
  const [count, setCount] = useState();
  const [isEditRate, setIsEditRate] = useState({
    drawerState: false,
    selectedRateId: "",
  });
  const prevCityRef = useRef(globalCityField.value?.id);

  const handleCityChange = (city) => {
    setCitySelected(city);
    setCityId(city.value.id);
  };

  // Utility to reset page and fetch safely
  const resetPageAndFetch = () => {
    setRatesPagination(prev => {
      if (prev.page === 0) {
        // Already at page 0 → fetch directly
        fetchTableData();
        return prev;
      }
      // Set page to 0 (main effect will fetch)
      return { ...prev, page: 0 };
    });
  };

  const fetchTableData = () => {
    const serviceCityId = globalCityField.value?.id || null;
    let obj = {
      serviceCityId: serviceCityId,
      page: ratesPagination.page,
      size: ratesPagination.rowsPerPage,
    };

    // getRatesList(obj)
    //   .then((result) => {
    //     setRatesList(result.data.list);
    //     setCount(result.data.count);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
     if (filterData.length == 0 && !searchData) {
       setLoading(true);
       getRatesList(obj)
         .then((result) => {
           setRatesList(result.data.list);
           setCount(result.data.count);
         })
         .catch((error) => {
           console.log(error);
           setRatesList([]);
           setCount(0);
         })
         .finally(() => {
           setLoading(false);
         });
     } else if (filterData.length > 0 && filterType == "filter") {
       filterData.forEach((d) => {
         // Use filterValues for API (contains ID), values is for display (contains label)
         obj[d.column_name] = d["filterValues"] ? d["filterValues"][0] : d["values"][0];
       });

       setLoading(true);
       getRatesListByFilter(obj)
         .then((result) => {
           setRatesList(result.data.searchResponse || result.data.list);
           setCount(result.data.count);
         })
         .catch((error) => {
           console.log(error);
           setRatesList([]);
           setCount(0);
         })
         .finally(() => {
           setLoading(false);
         });
     }
    
  };

  // Combined effect: Reset pagination on city change and fetch data
  useEffect(() => {
    const cityChanged = prevCityRef.current !== globalCityField.value?.id;
    prevCityRef.current = globalCityField.value?.id;

    // City changed → reset page first
    if (cityChanged) {
      resetPageAndFetch();
      return;
    }

    // Normal fetch when page or rows-per-page changes
    fetchTableData();
  }, [
    globalCityField.value?.id,
    ratesPagination.page,
    ratesPagination.rowsPerPage
  ]);

  // Filter effect
  useEffect(() => {
    if (filterData.length === 0 && filterType !== "filter") return;
    resetPageAndFetch();
  }, [filterData, filterType]);

  const handleChecked = () => {
    setChecked(!isChecked);
  };
  // pagination
  const handleChangePage = (event, newPage) => {
    setRatesPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRatesPagination({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };
  
  const totalPages = Math.floor(count / ratesPagination.rowsPerPage);

  // this function will convert time from , time to data from seconds to hours
  const convertTo24Hr = (seconds) => {
    if (seconds === 86400) return "24:00"; // special case
    return moment.utc(seconds * 1000).format("HH:mm");
  };

  const handleEditRateDrawer = (state) => {
    setIsEditRate((prev) => ({
      ...prev,
      drawerState: false,
      selectedRateId: state ? prev.selectedRateId : "",
    }));
  };

  const getAirportData = (id) => {
    const airport = airportData.find((airport) => airport.id === id);
    return airport;
  }

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };
  return (
    <div
      style={{
        flex: 1,
        width: "100%",
      }}
    >
      <div style={{}}>
        {/* <TableViewIcon
          color="#00000"
          sx={{
            fontSize: 35,
          }}
        />

        <Switch checked={isChecked} onChange={handleChecked} color="success" />

        <CalendarTodayIcon
          color="#00000"
          sx={{
            fontSize: 30,
          }}
        />
      </div>

      {isChecked ? (
        <div>
          <Rates serviceCityId={cityId} />
        </div>
      ) : ( */}

        {/* the below code is the old UI of rate tab which displays rates in grid cards */}
        {/* <Grid container spacing={2}>
            {ratesList.map((rate, index) => (
              <Grid
                key={index}
                item
                sm={8}
                md={6}
                lg={4}
                xl={3}
                columnSpacing={20}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(120deg,#D5FFDC 0%, #FFFFF0 100%)",
                    height: 200,
                    borderRadius: 5,
                    padding: "20px 20px",
                    cursor: "pointer",
                    boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
                    alignContent: "center",
                    textAlign: "center",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                    }}
                  >
                    <tr>
                      <td className="p-head"> Time From </td>
                      <td className="p-dtls">
                        {String(
                          new Date(rate.applicableFromDate).getHours()
                        ).padStart(2, "0")}
                        :00
                      </td>
                    </tr>
                    <tr>
                      <td className="p-head">Time To </td>
                      <td className="p-dtls">
                        {String(
                          new Date(rate.applicableToDate).getHours()
                        ).padStart(2, "0")}
                        :00
                      </td>
                    </tr>
                    <tr>
                      <td className="p-head"> Per KM Charge </td>
                      <td className="p-dtls">
                        <CurrencyRupeeIcon
                          sx={{ color: "#000", fontSize: "0.7rem" }}
                        />
                        {rate.perKmCharge}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-head"> Available From </td>
                      <td className="p-dtls">
                        {new Date(rate.applicableFromDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          }
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-head">Available From </td>
                      <td className="p-dtls">
                        {new Date(rate.applicableToDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          }
                        )}
                      </td>
                    </tr>
                  </table>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              padding: 4,
            }}
            display="flex"
            justifyContent="right"
            alignItems="center"
          >
        
          
            <TablePagination
             size="large"
             component="div"
             count={count}
             page={pagination.page}
             onPageChange={handleChangePage}
             rowsPerPage={pagination.rowsPerPage}
             onRowsPerPageChange={handleChangeRowsPerPage}
             rowsPerPageOptions={	[10, 25, 30]}
             sx={{
              // Select label element styles
              '& .MuiTablePagination-selectLabel': {
                m:'auto'
              },
          
              // Select icon styles
              '& .MuiTablePagination-displayedRows': {
               m:'auto'
              },
            }}
            />
          </Box> */}

        {/* the below UI is the latest current UI wich shows rates in table format */}
        {!loading && ratesList.length == 0 ? (
          <>
            {" "}
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
              }}
            >
              <Typography sx={{ color: "black" }}>
                No Rates Available
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <TableContainer
              component={Paper}
              aria-label="sticky table"
              sx={{
                maxHeight: "33vw",
                overflowY: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        color: "#626262",
                        fontWeight: "bold",
                        fontSize: "1.11vw",
                        backgroundColor: "#E1F4E4",
                        padding: "10px",
                      },
                    }}
                  >
                    <TableCell>
                      <Box sx={{ textAlign: "left" }}>Service City</Box>
                    </TableCell>

                    <TableCell align="left">Car Type</TableCell>
                    <TableCell align="left">Time From</TableCell>
                    <TableCell align="left">Time To</TableCell>
                    <TableCell align="center">Initial Distance(Km)</TableCell>
                    <TableCell align="center">Per Km Charge</TableCell>
                    {/* <TableCell align="center">Terminal</TableCell> */}
                    <TableCell align="center">Status</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading
                    ? [...Array(7)].map((_, index) => (
                        <TableRow key={index}>
                          {[...Array(7)].map((__, i) => (
                            <TableCell key={i}>
                              <Skeleton animation="wave" width="100%" />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    : ratesList.map((singleRateData) => (
                        <TableRow
                          key={singleRateData.id}
                          sx={{
                            "&:hover": {
                              // cursor: "pointer",
                              backgroundColor: "#EBEBEB",
                            },
                            "&:last-child td, &:last-child th": { border: 0 },
                            "& td": {
                              fontSize: "1.11vw",
                              borderBottom: "none",
                            },
                          }}
                        >
                          <TableCell>
                            <Box
                              sx={{
                                textAlign: "left",
                                fontSize: "1vw",
                                color: "black",
                                fontWeight: "bold",
                              }}
                            >
                              {singleRateData.serviceCityName ?? "-"}
                            </Box>
                          </TableCell>

                          <TableCell align="left">
                            <Box
                              sx={{
                                textAlign: "left",
                                fontSize: "1vw",
                                color: "#39B54A",
                                fontWeight: "600",
                              }}
                            >
                              {singleRateData.carTypeName ?? "-"}
                            </Box>
                          </TableCell>

                          <TableCell align="left">
                            <Box sx={{ color: "#313131", fontSize: "1vw" }}>
                              {singleRateData.timeFrom != null
                                ? convertTo24Hr(singleRateData.timeFrom)
                                : "-"}
                            </Box>
                          </TableCell>

                          <TableCell align="left">
                            <Box
                              sx={{
                                textAlign: "left",
                                color: "black",
                                fontSize: "0.97vw",
                              }}
                            >
                              {singleRateData.timeTo != null
                                ? convertTo24Hr(singleRateData.timeTo)
                                : "-"}
                            </Box>
                          </TableCell>

                          <TableCell align="center">
                            <Box
                              sx={{
                                // textAlign: "left",
                                fontSize: "1vw",
                                color: "#313131",
                              }}
                            >
                              {singleRateData.initialDist ?? "-"}
                            </Box>
                          </TableCell>

                          <TableCell align="center">
                            <Box
                              sx={{
                                display: "inline-block",
                                wordWrap: "break-word",
                                maxWidth: "12vw",
                                fontSize: "1vw",
                                color: "#313131",
                              }}
                            >
                              {singleRateData.perKmCharge ?? "-"}
                            </Box>
                          </TableCell>
                        {/* <TableCell align="center">
                            <Box
                              sx={{
                                display: "inline-block",
                                wordWrap: "break-word",
                                maxWidth: "12vw",
                                fontSize: "1vw",
                                color: "#313131",
                              }}
                            >
                              {getAirportData(singleRateData.airportId)?.name ?? "-"}
                            </Box>
                          </TableCell> */}

                          <TableCell align="left">
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                                maxWidth: "12vw",
                                fontSize: "1vw",
                                color: "#313131",
                                gap:'0.6vw'
                              }}
                            >
                              {singleRateData.isActive ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    backgroundColor: "#E3F5E1",
                                    width: "6.11vw",
                                    height: "2.01vw",
                                    justifyContent: "space-evenly",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    border: "1px solid rgba(116, 206, 106, 1)",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "0.56vw",
                                      height: "0.56vw",
                                      background: "rgba(116, 206, 106, 1)",
                                      borderRadius: "50%",
                                    }}
                                  />
                                  <Typography sx={{ fontSize: "0.97vw" }}>
                                    Active
                                  </Typography>
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                    width: "6.11vw",
                                    height: "2.01vw",
                                    borderRadius: "6px",
                                    backgroundColor: "#ffe5e5",
                                    border: "1px solid #cc0000",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "0.56vw",
                                      height: "0.56vw",
                                      backgroundColor: "#cc0000",
                                      borderRadius: "50%",
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "0.97vw",
                                      color: "#cc0000",
                                    }}
                                  >
                                    InActive
                                  </Typography>
                                </Box>
                              )}

                              <img
                                src={editBlackIcon}
                                alt="edit"
                                style={{ width: "1.75vw", height: "1.61vw",cursor:'pointer' }}
                                onClick={() =>
                                  setIsEditRate((prev) => ({
                                    ...prev,
                                    drawerState: true,
                                    selectedRateId: singleRateData.id,
                                  }))
                                }
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={count}
              page={ratesPagination.page}
              onPageChange={handleChangePage}
              rowsPerPage={ratesPagination.rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[7, 10, 25, 50]}
              sx={{
                "& .MuiTablePagination-toolbar": {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: 2,
                  textAlign: "center",
                  overflowX: "hidden",
                },
                // dropdown style
                "& .MuiTablePagination-select": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  borderRadius: "6px",
                  paddingX: "8px",
                  paddingY: "4px",
                  border: "1px solid #D9D9D9",
                },

                // arrows bigger and green
                "& .MuiTablePagination-actions button": {
                  color: "rgba(112, 112, 112, 1)",
                  transform: "scale(1.3)",
                },

                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    color: "rgba(98, 98, 98, 1)",
                    fontSize: "0.97vw",
                    textAlign: "center",
                    m: "auto",
                    letterSpacing: "0.02vw",
                  },
              }}
            />
          </>
        )}

        <RateInput
          editId={isEditRate.selectedRateId}
          open={isEditRate.drawerState}
          setIsOpen={handleEditRateDrawer}
          fetchTableData={fetchTableData}
        /> 
       
      </div>
    </div>
  );
}

export default RatesListView;
